import React from "react";

export const Button = ({
  children,
  small = false,
  lined = false,
  color = "blue",
  disabled,
  className,
  type = "submit",
  onClick,
}) => {
  const newClass =
    className ||
    `button button--primary-dark button--16 button--width-auto${
      small ? " button--small" : ""
    }${
      lined ? " button--lined" : " button--bordered-transparent"
    } button--${color}`;

  return (
    <button
      {...{
        className: newClass,
        type,
        disabled,
        onClick,
      }}
    >
      {children}
    </button>
  );
};
